var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMmusicLogoWhiteSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1558 14.3924L27.9574 13.1561C26.1014 12.1106 23.7455 12.4853 22.3274 14.0519C22.2711 14.1129 22.2149 14.1762 22.1632 14.2412L21.3447 15.2503V10.9399C21.3447 10.0115 20.8361 9.15397 20.0102 8.68994L15.4967 6.15009C13.6554 5.11561 11.3129 5.55534 9.9984 7.18253L9.05895 8.34534V4.03082C9.05789 3.10345 8.54932 2.24691 7.72444 1.78322L5.3837 0.468813C3.66716 -0.496204 1.47193 0.0763044 0.480803 1.74797C0.16519 2.2801 -0.0007007 2.88409 2.2246e-06 3.49869V31.5061C0.000353687 33.4361 1.60759 35.0003 3.58984 35C4.21966 35 4.83823 34.8385 5.3837 34.5319L7.72479 33.2178C8.54757 32.7562 9.05613 31.903 9.0593 30.9784V20.0741L10.0958 17.9421L12.2878 13.4278V28.853C12.3005 29.4334 12.7939 29.8943 13.39 29.882C13.5654 29.8786 13.7369 29.8334 13.8901 29.7506L20.8136 25.8607C21.1419 25.6722 21.3436 25.3296 21.345 24.9587V22.9886L24.5648 16.4032L24.5778 16.38V21.9374C24.576 22.5109 25.0519 22.9777 25.6409 22.9794C25.8286 22.9801 26.0131 22.9325 26.1755 22.8415L30.1555 20.6041C31.9188 19.6134 32.5236 17.4182 31.5058 15.7014C31.1821 15.1552 30.7164 14.7018 30.1555 14.3866V14.3928L30.1558 14.3924Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2876 11.0024C12.2876 7.65286 10.6743 7.0913 9.68111 7.57723C9.27095 8.05666 9.05902 8.34685 9.05902 8.34685V20.0756L12.2876 13.4269V11.0024Z",
    fill: "#CED9EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3271 14.0531C24.1973 13.6914 24.5167 15.4325 24.5645 16.4016L21.3448 22.9894V15.2515L22.3275 14.0531H22.3271Z",
    fill: "#CED9EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmusicLogoWhiteSmall);
export default __webpack_public_path__ + "static/media/mmusic-logo-white-small.9830a118aab94f749a92fbe1bd7e158d.svg";
export { ForwardRef as ReactComponent };